import { FC, ReactNode, useCallback, useEffect, useMemo } from 'react';
import { EventBus, EventGoToForms } from '../../types/event-bus';
import { useEventBus } from '../use-event-bus';
import { useHistory } from '../use-history-intercept';
import { FormsAppContext, IFormsAppContext } from './context';

export interface FormsAppProviderProps {
  children: ReactNode;
}

export const FormsAppProvider: FC<FormsAppProviderProps> = ({ children }) => {
  const { listen } = useEventBus();
  const history = useHistory();

  const goToForms = useCallback(
    (formId: string, locationIdSelected?: number) => {
      if (history.location.pathname.includes(`/forms/submissions/index/${formId}`)) {
        return;
      }

      history.push({
        pathname: `/forms/submissions/index/${formId}`,
        search: locationIdSelected ? `?locationId=${locationIdSelected}` : ''
      });
    },
    [history]
  );

  const handleGoToForms = useCallback(
    async (event: EventBus) => {
      const goToFormsEvent = event as EventGoToForms;

      goToForms(
        goToFormsEvent.data.formId || '',
        goToFormsEvent.data.locationId
      );
    },
    [goToForms]
  );

  useEffect(() => listen('go-to-forms', handleGoToForms), [listen, handleGoToForms]);

  const contextValue: IFormsAppContext = useMemo(
    () => ({
      goToForms
    }),
    [goToForms]
  );

  return <FormsAppContext.Provider value={contextValue}>{children}</FormsAppContext.Provider>;
};
